<template>
  <WdsLabel :success="column.paidAt" :error="!column.paidAt" xs subtle>
    {{ statusText }}
  </WdsLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { useTranslation } from '@/composables/translation'

const PaymentRequestStatusColumn = graphql(`
  fragment PaymentRequestStatusColumn on PaymentRequest {
    id
    paidAt
    issuedAt
    workerStatus
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestStatusColumn>
}>()

const { $t } = useTranslation()

const column = computed(() => useFragment(PaymentRequestStatusColumn, props.row))

const statusText = computed(() => {
  if (column.value.paidAt) {
    return $t('Paid')
  }
  return $t('Not paid')
})
</script>

<style scoped></style>
